import React from 'react';
import { slugCreator } from '../../../core/useStore';
import { SVBSearchResult } from '@svb/portal-ui-react-components/dist/react-molecule/SVBSearch';
import getApiBusinessDocPath from '../../../helpers/utilityCustomHooks/getApiBusinessDocPath';
import searchCardConstants from '../../../helpers/static/searchCardConstants';

function searchBuildResultArray(data) {
  let buildMainresultArray = [];
  if (data) {
    for (const [key, value] of Object.entries(data)) {
      let keyToLowerCase = key.toLowerCase();

      if (value && value.total_items && value.total_items > 0) {
        let arrangeCardJson = [];
        value.items.map((resultItem) => {
          if (!(resultItem?.api_status && resultItem?.api_status.toLowerCase() === 'deprecated')) {
            // Build cards for all the results except for deprecated apis
            arrangeCardJson.push({
              title: resultItem?.api_display_name || resultItem?.title || resultItem?.name,
              description: resultItem?.api_summary || resultItem?.description,
              searchType: searchCardConstants.cardVariationClass[key]
                ? searchCardConstants.cardVariationClass[key]
                : searchCardConstants.cardVariationClass['default'],
              resourceLink: keyToLowerCase.includes('api')
                ? `${getApiBusinessDocPath(
                    resultItem?.name,
                    resultItem?.version,
                    resultItem?.solution_type,
                  )}`
                : keyToLowerCase.includes('faq')
                ? `/faqs/${slugCreator(resultItem.title)}`
                : resultItem?.link || '',
              categories: {
                tagsPosition: 'header',
                tags: [
                  {
                    label: searchCardConstants.tagLabels[key]
                      ? searchCardConstants.tagLabels[key]
                      : searchCardConstants.tagLabels['default'],
                    type: searchCardConstants.cardVariationClass[key]
                      ? searchCardConstants.cardVariationClass[key]
                      : searchCardConstants.cardVariationClass['default'],
                  },
                ],
              },
            });
          }
        });
        buildMainresultArray.push(
          <SVBSearchResult
            key={key}
            categoryType={
              searchCardConstants.categorySectionTitle[key]
                ? searchCardConstants.categorySectionTitle[key]
                : searchCardConstants.categorySectionTitle['default']
            }
            categoryTypeLink={
              searchCardConstants.showMoreLink[key]
                ? searchCardConstants.showMoreLink[key]
                : searchCardConstants.showMoreLink['default']
            }
            cardJson={arrangeCardJson}
            resultLimit={3}
          />,
        );
      }
    }
  }
  return buildMainresultArray;
}
export default searchBuildResultArray;
